import { createApi } from "@reduxjs/toolkit/dist/query/react";
import { contractBaseQuery } from "./contract.base-query";
import { EApiSourceName } from "./types";

const signerApi = createApi({
  reducerPath: "signerApi",
  baseQuery: contractBaseQuery,
  endpoints: (builder) => ({
    signMessage: builder.mutation<string, any>({
      query: (message) => ({
        contractAddress: "signer",
        method: "signMessage",
        contractName: EApiSourceName.SIGNER,
        callData: [message],
      }),
    }),
  }),
});

export const { useSignMessageMutation } = signerApi;

export default signerApi;
